import React, { memo } from 'react';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/shadcn-ui/table';
import { Button } from '../shadcn-ui/button';

const UserTable = memo(({ users }) => {
  return (
    <Table>
      <TableHeader>
        <TableRow>
          <TableHead>Name</TableHead>
          <TableHead>Role</TableHead>
          <TableHead>Phone</TableHead>
          <TableHead>Status</TableHead>
          <TableHead className="text-right">Actions</TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {users?.length === 0 && (
          <TableRow>
            <TableCell colSpan={5} className="text-center text-sm py-8 text-slate-400">
              No users found.
            </TableCell>
          </TableRow>
        )}

        {users?.map(user => (
          <TableRow key={user._id}>
            <TableCell className="font-medium">{user?.fullname}</TableCell>
            <TableCell>{user.client_details[0].client_role}</TableCell>
            <TableCell>{user.phone_number}</TableCell>
            <TableCell>
              <span
                className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium ${
                  user.status === 'Active' ? 'bg-emerald-50 text-emerald-700' : 'bg-amber-50 text-amber-700'
                }`}
              >
                {user.status}
              </span>
            </TableCell>
            <TableCell className="text-right">
              <Button variant="ghost" size="sm" className="text-xs">
                Edit
              </Button>
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
});

export default UserTable;
